import { useProjectSettings } from 'frontastic';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface Props {
  setIsReCaptchaVerified: (isRecaptchaVerified: boolean) => void;
  setReCaptchaError: (isRecaptchaError: boolean) => void;
}
const ReCaptchaUI = ({ setIsReCaptchaVerified, setReCaptchaError }: Props) => {
  const { data: config } = useProjectSettings();

  if (config?.recaptchaEnabled !== undefined && !config?.recaptchaEnabled) {
    setIsReCaptchaVerified(true);
    setReCaptchaError(false);
    return <></>;
  }

  const handleChange = (res: string | null) => {
    if (res) {
      setIsReCaptchaVerified(true);
      setReCaptchaError(false);
    }
  };

  return (
    <div className="mt-4">
      {config?.recaptchaKey && (
        <>
          <ReCAPTCHA onChange={(res) => handleChange(res)} sitekey={config?.recaptchaKey} />
        </>
      )}
    </div>
  );
};

export default ReCaptchaUI;
